var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayleftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 431,
    height: 716,
    viewBox: "0 0 431 716",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M307.627 694.207L20.9067 408.233C6.71869 394.045 2.78699e-05 376.129 2.78699e-05 357.463C2.78699e-05 338.796 6.71882 320.875 20.9067 306.692L307.627 20.7187C335.252 -6.9066 380.799 -6.9066 409.173 20.7187C437.548 48.3441 436.799 93.8907 409.173 122.265L173.227 357.465L409.173 593.412C436.799 621.037 436.799 666.584 409.173 694.959C381.543 723.328 335.996 722.584 307.627 694.209V694.207Z",
    fill: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayleftArrow);
export default __webpack_public_path__ + "static/media/grayleftArrow.f6baafd4ab7005f3c969643db41c1fe1.svg";
export { ForwardRef as ReactComponent };